//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'CATCH',
  data() {
    return {
      form:{
        inc_1:'0',
        inc_2:'0',
        inc_3:'0',
        inc_4:'0',
        inc_5:'0',
        inc_6:'0',

        high_1:'0',
        high_2:'0',
        high_3:'0',
        high_4:'0',

        med_1:'0',
        med_2:'0',
        med_3:'0',

      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Witnessed loss of consciousness": "意识障碍",
        "Injury within 24h": "24h 内受伤",
        "Not applicable": "不适用",
        "Sign(s) of basal skull fracture": "颅底骨折体征",
        "persistent hint": "持续呕吐（一次以上）或持续躁动（2 岁以下儿童）",
        "bsfCriteria": "如鼓室出血、「熊猫」眼、耳漏或鼻漏、Battle 征",
        "GCS 13 - 15": "GCS 13 - 15",
        "Suspected open or depressed skull fracture": "疑似颅骨开放性或凹陷性骨折",
        "Large, boggy hematoma": "巨大质软的血肿",
        "Medium Risk": "中危",
        "Irritability on examination": "体检时反应过度",
        "Persistent vomiting or persistent irritability": "持续呕吐或持续躁动",
        "Inclusion Criteria": "收入标准（轻度头部外伤）",
        "GCS < 15 at 2 hours after injury": "伤后 2 小时 GCS < 15",
        "High Risk": "高危",
        "Witnessed disorientation": "定向障碍",
        "Dangerous mechanism": "危险机制",
        "Hx of worsening headache": "头痛加重病史",
        "dmCriteria": "如撞车、从高于1米处或5级台阶以上跌落、未戴头盔从自行车上摔倒",
        "Definite amnesia": "明确的贫血",
        "CT required (high risk)": "需要行 CT 检查（高危）",
        "CT not required": "无需 CT 检查",
        "CT required (medium risk)": "需要行 CT 检查（中危）"
      },
      inclusion:0,
      high:0,
      med:0,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // ((inc_1 + inc_2 + inc_3 + inc_4 + inc_5 + inc_6) &gt; 5) ? 1 : 0
        self.inclusion = ((form.inc_1 + form.inc_2 + form.inc_3 + form.inc_4 + form.inc_5 + form.inc_6) > 5) ? 1 : 0
        // high_1 + high_2 + high_3 + high_4
        self.high = form.high_1 + form.high_2 + form.high_3 + form.high_4
        // med_1 + med_2 + med_3
        self.med = form.med_1 + form.med_2 + form.med_3

        // (inclusion > 0) ? ((high > 0) ? 2 : ((med > 0) ? 1: 0 )): -1

        let result =  (self.inclusion > 0) ? ((self.high > 0) ? 2 : ((self.med > 0) ? 1: 0 )): -1
        self.hasScore = true
        return String(result)
      }
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/CATCH.vue